/**
 * A ReportDef Factory.
 * 
 * Implements empty(), import(), export()
 * MAZ - 2020-12-21
 */
import { cloned, copyAttrsOnly, CustomException } from '@/helpers'

const _EMPTY = {
  id: -1,
  account_id: -1,
  state: "",
  title: "",
  descr: "",
  alias: "" , 
  tags: "",
  roles: [],
  // the report configuration itself
  builder: "",
  definition: {}, // depends on Builder
  params: [],
  // who and when 
  creator_id: -1,
  created_date: "",
  updater_id: -1,
  updated_date: ""  
}

const _XLS_BUILDER_DEF = {
  // XLS template file UUID for this report, 
  // resides in the account repo (var/lib/tremes/files/:ACCOUNT_ID)
  template_file: { uuid:'', name:'', type:'', full_name:'' },
  injects: [ 
    // { query: "", into: "" }
  ] 
}

const _BUILDER_DEFS = {
  'xls-builder': _XLS_BUILDER_DEF
}


export const ReportDef = {

  _key: 'report-def', // used in Schema and for Obj Idn

  _readOnly: [
    'id','account_id',
    'creator_id', 'created_date',
    'updater_id','updated_date'
  ],

  empty(type) {
    /**
     * Returns an EMPTY instance.
     * @returns: initialized RecordDefInstance
     */
    let oi = cloned(_EMPTY);
    return oi;
  },

  emptyDefinition(type) {
    return cloned(_BUILDER_DEFS[type] || {});
  },

  import (obj) {
    /**
     * Import a JSON obj coming from the API
     */
    let oi = this.empty();
    oi = copyAttrsOnly(oi, obj);
    return oi;
  },

  export (oi) {
    /**
     * Export an instance for the API
     */
    oi.state = oi.state || 'E';
    // remove readonly props
    this._readOnly.map((k) => { delete oi[k]; })
    return oi;
  },
}
